export const en = {
  'hx': {
    'all': 'All',
    'atol': {
      'taxationType': {
        'esn': 'unified agricultural tax',
        'osn': 'general',
        'patent': 'patent tax system',
        'usnIncome': 'simplified income',
        'usnIncomeOutcome': 'simplified income minus expense'
      }
    },
    'bank-account-select': {
      'placeholder': {
        'selectBank': 'Select a bank account'
      }
    },
    'bank-select': {
      'selectBank': 'Select a bank'
    },
    'brand-select': {
      'selectBrand': 'Choose a brand'
    },
    'btn': {
      'apply': 'Apply',
      'back': 'Back',
      'cancel': 'Cancel',
      'close': 'To close',
      'save': 'Save'
    },
    'call-audio': {
      'play': 'Play it back'
    },
    'city-select': {
      'selectCity': 'Choose a city'
    },
    'client-checker': {
      'bonus': 'Bonuses',
      'mobileNum': 'Mobile numbers only',
      'ng': {
        'clear': 'Clear'
      },
      'placeholder': {
        'num': 'New'
      },
      'addBirthDateNote': 'Add Date of Birth'
    },
    'client-edit': {
      'activeCoins': 'Bonuses',
      'btn': {
        'addMail': 'Add an e-mail',
        'addNote': 'Add a note',
        'addPhone': 'Add a phone number'
      },
      'client': 'Customer Data',
      'coins': 'Bonuses',
      'coin': {
        'th': {
          'activationDate': 'Active since',
          'amount': 'Quantity',
          'expireDate': 'Active until',
          'operation': 'Operation'
        }
      },
      'comment': {
        'title': 'Comments',
        'date': 'Date',
        'actor': 'Actor'
      },
      'happyDay': 'Birthday',
      'info': 'Additional information',
      'mobileNum': 'Mobile numbers only',
      'mobileNumber': 'Mobile number',
      'name': 'Full name/name',
      'ng': {
        'change': 'To change',
        'delete': 'Remove',
        'deleteContact': 'Delete a contact'
      },
      'num': 'Phone number',
      'table': {
        'body': {
          'blacklist': 'in the blacklist'
        },
        'head': {
          'blacklist': 'Blacklist',
          'brand': 'Brand',
          'note': 'A note'
        }
      },
      'ts': {
        'clientExists': 'There is a client with this number',
        'commentEmpty': 'Comments are not filled in',
        'dataUpdated': 'The data has been updated',
        'error': 'An error has occurred',
        'mail': 'Email',
        'phone': 'Telephone',
        'textNum': 'Enter your mobile phone number'
      }
    },
    'client-edit-modal': {
      'changeProfile': 'Change the client\'s profile',
      'profile': 'New client profile'
    },
    'client-indicator': {
      'nb': {
        'blacklist': 'blacklist: {{ blackListInfo }}',
        'note': 'notes: {{client}}'
      }
    },
    'client-list': {
      'btn': {
        'search': 'search'
      },
      'ng': {
        'change': 'To change',
        'time': 'Save time: {{date }} - by Astana time'
      },
      'placeholder': {
        'name': 'Full name or phone number'
      },
      'table': {
        'head': {
          'happyDay': 'Birthday',
          'name': 'Full name/name ',
          'num': 'Number'
        }
      }
    },
    'client-property-edit-modal': {
      'blacklisted': 'Blacklisted',
      'brand': 'Brand',
      'no': 'No',
      'note': 'Note',
      'title': 'A note on the client',
      'ts': {
        'save': 'The data is saved'
      },
      'yes': 'Yes'
    },
    'client-search': {
      'placeholder': {
        'loading': 'A search is underway...',
        'nameClient': 'Enter the customer\'s name or phone number',
        'noFind': 'Not found'
      }
    },
    'closed': 'Closed',
    'cmp': {
      'gis-address': {
        'hasNoDelivery': 'We do not deliver'
      }
    },
    'comment-list': {
      'actor': 'The author',
      'addComment': 'Add a comment',
      'comment': 'Comment',
      'date': 'Date',
      'previous': 'is the previous one'
    },
    'company': {
      'address': 'Address',
      'contract': 'Footing',
      'letterOfAuthorityDate': 'Date',
      'letterOfAuthorityFileId': 'Attorney',
      'letterOfAuthorityFileLink': {
        'tooltip': 'View the uploaded power of attorney'
      },
      'letterOfAuthorityFile': {
        'uploaded': 'The power of attorney has been uploaded!',
        'uploadRequired': 'You need to download the power of attorney!'
      },
      'letterOfAuthorityNumber': 'Number',
      'representativeFullname': 'Full name/name',
      'saveForAuthorityForm': 'Save your company information',
      'title': 'Name',
      'uin': 'BIN'
    },
    'confirm': {
      'cancel': 'Cancel',
      'ok': 'ok',
      'title': 'Confirmation of the action'
    },
    'country-select': {
      'placeholder': {
        'chooseCountry': 'Select a country'
      }
    },
    'data-select': {
      'btn': {
        'close': 'To close',
        'today': 'Today'
      }
    },
    'daterangepicker': {
      'lastMonth': 'Last month',
      'lastQuarter': 'Last quarter',
      'lastWeek': 'Last week',
      'month': 'Month',
      'quarter': 'Quarter',
      'week': 'A week'
    },
    'date-range-select': {
      'lastMonth': 'Last month',
      'lastQuarter': 'Last quarter',
      'lastWeek': 'Last week',
      'month': 'Month',
      'quarter': 'Quarter',
      'week': 'A week'
    },
    'dictionary-select': {
      'placeholder': {
        'selectExpense': 'Select the type of expense'
      }
    },
    'diff': {
      'deliveryType': {
        'DELIVERY': 'Delivery by courier',
        'PICKUP': 'Pickup'
      },
      'is': {
        'false': 'removed',
        'happy': {
          'apps': {
            'vanilla': {
              'event': {
                'dto': {
                  'OrderDiffDto': {
                    'action': 'Action',
                    'address': 'Address',
                    'bookedClient': 'The booked customer',
                    'cartExpireDate': 'Shopping Cart time',
                    'cartRangeId': 'Delivery time (shopping cart)',
                    'cashless': 'Cashless',
                    'cityId': 'City',
                    'clientCash': 'Cash',
                    'clientId': 'Client',
                    'currency': 'Currency',
                    'date': 'Date',
                    'decor': 'Decoration',
                    'decored': 'Decorated',
                    'decorText': 'Decoration',
                    'deliveryLatitude': 'Width',
                    'deliveryLongitude': 'Longitude',
                    'deliveryRangeId': 'Delivery Time',
                    'deliveryTimeRange': 'Specify the time for the courier',
                    'deliveryType': 'Type of delivery',
                    'deliveryUserId': 'Courier',
                    'employeeId': 'Employee discount',
                    'enabled': 'Active',
                    'entrance': 'Entrance',
                    'fiscalDate': 'Date of the fisk.',
                    'flat': 'Flat',
                    'floor': 'Floor',
                    'important': 'Favourites',
                    'inscription': 'Inscription',
                    'invoice': 'The invoice',
                    'locked': 'Blocked',
                    'modifyDate': 'Date of change',
                    'modifyUserId': 'Changed',
                    'note': 'Note',
                    'number': 'Number',
                    'operationType': 'Type of operation',
                    'organizationTitle': 'The name of the organization.',
                    'organizationUin': 'IIN/BIN org.',
                    'paid': 'Payment status',
                    'paidActor': 'Accepted the payment',
                    'parentOrderId': 'The main order',
                    'payment': 'Payment',
                    'paymentDate': 'Date of payment',
                    'paymentUserFullname': 'Accepted the payment',
                    'paymentUserId': 'Accepted payment (id)',
                    'phone': 'Telephone',
                    'rahmet': 'Rahmet',
                    'removed': 'Deleted',
                    'revoked': 'Returned',
                    'seen': 'Viewed',
                    'seenUserIds': 'Viewed by whom',
                    'senim': 'SENIM',
                    'sourceFrom': 'Order Source',
                    'status': 'Status',
                    'storeId': 'Shop',
                    'storePaymentType': 'Payment type',
                    'subTotal': 'Total',
                    'taxNumber': 'Tax number',
                    'taxSeries': 'The tax regime',
                    'taxSum': 'The amount of tax',
                    'total': 'Total',
                    'underSalary': 'Status under the po',
                    'uniqueNumber': 'Unique number',
                    'wkCashboxFactoryNumber': 'CFN',
                    'wkCashboxRegistrationNumber': 'CRN',
                    'wkCashboxTaxNumber': 'Fiscal number',
                    'wkFiscalNumber': 'FN'
                  }
                }
              }
            }
          },
          'dao': {
            'hc': {
              'dto': {
                'payment': {
                  'PaymentInfoDto': {
                    'payment/cash': 'Cash',
                    'payment/checkingAccount': 'Payment order',
                    'payment/dept': 'Debt',
                    'payment/forte': 'FortePay',
                    'payment/halyk': 'HalykPay',
                    'payment/kaspi': 'kaspi.kz',
                    'payment/pos': 'POS',
                    'payment/rahmet': 'Rahmet',
                    'payment/senim': 'Senim'
                  }
                }
              }
            }
          }
        },
        'paid': {
          'false': 'not paid',
          'true': 'paid'
        },
        'true': 'added'
      },
      'kind': {
        'A': 'added(a) to the list',
        'D': 'deleted(a)',
        'E': 'changed(a)',
        'N': 'added(a)'
      },
      'path': {
        'address': 'Address',
        'callId': 'Recording a call',
        'cash': 'Cash',
        'cashless': 'Cashless',
        'checkingAccountFileId': 'Payment order',
        'city': 'City',
        'clientCash': 'Cash',
        'clientId': 'Client',
        'clientType': 'Type of client',
        'courier': 'Courier',
        'date': 'Date',
        'decorText': 'Decoration',
        'deliveryLatitude': 'Width',
        'deliveryLongitude': 'Longitude',
        'deliveryTimeRange': 'Specify the time for the courier',
        'deliveryType': 'Type of delivery',
        'discounts': 'Discounts',
        'employeeId': 'Employee discount',
        'entrance': 'Entrance',
        'files': 'Files',
        'flat': 'Flat',
        'floor': 'Floor',
        'from': 'Order Source',
        'important': 'Favourites',
        'invoice': 'The invoice',
        'note': 'Note',
        'paid': 'Payment status',
        'paymentType': 'Payment type',
        'phone': 'Telephone',
        'products': 'Products',
        'rahmet': 'Rahmet',
        'reason': 'Reason',
        'senim': 'SENIM',
        'store': 'Shop',
        'subTotal': 'Total',
        'total': 'Total',
        'underSalary': 'Status under the po'
      }
    },
    'enum': {
      'AccountType': {
        'BANK_ACCOUNT': 'Non-cash',
        'CASH': 'Cash'
      },
      'AccrualType': {
        'DAILY': 'daily',
        'HOURLY': 'hourly',
        'MONTHLY': 'monthly'
      },
      'CoinOperation': {
        'CANCELLED': 'Cancelled',
        'EARNED': 'Earned',
        'SPENT': 'Spent'
      },
      'ComponentType': {
        'cb': 'Cash',
        'cc': 'Call-center',
        'cf': 'Confectionery',
        'delivery': 'Courier',
        'kiosk': 'Kiosk',
        'manager': 'Manager',
        'profile': 'Profile'
      },
      'Currency': {
        'AZN': 'AZN/manat',
        'EUR': 'EUR/euro',
        'KGS': 'KGS/som',
        'KZT': 'KZT',
        'RUB': 'RUB/ruble',
        'USD': 'USD/dollar',
        'UZS': 'UZS/so\'m'
      },
      'EmployeeType': {
        'EMPLOYEE': 'permanent contract',
        'TEMP': 'temporary contract'
      },
      'Gender': {
        'FEMALE': 'F/female',
        'MALE': 'M/male'
      },
      'InvoiceStatus': {
        'ACCEPTED': 'accepted',
        'CANCELLED': 'cancelled',
        'DISCARDED': 'Discarded ',
        'INVENTORY': 'inventory',
        'NEW': 'created',
        'REJECTED': 'rejected',
        'RESTORATION': 'restoration',
        'SENT': 'sent',
        'SHIPMENT': 'on delivery'
      },
      'MaritalStatus': {
        'DIVORCED': 'divorced',
        'MARRIED': 'married',
        'SINGLE': 'not married',
        'WIDOWED': 'widow/widower'
      },
      'OperationType': {
        'ADJUSTMENT': 'Adjustment',
        'COLLECTION': 'Collection',
        'PURCHASE': 'Purchase',
        'WITHDRAWAL': 'Withdrawal'
      },
      'PaymentType': {
        'CASH': 'Cash',
        'CHECKING_ACCOUNT': 'Payment order',
        'COIN': 'Bonuses',
        'DEBT': 'Debt',
        'FORTE': 'Forte',
        'HALYK': 'Halyk',
        'KASPI': 'kaspi',
        'KASPI_POS': 'kaspi POS',
        'PAYBOX': 'Paybox',
        'POS': 'POS',
        'RAHMET': 'Rahmet',
        'SENIM': 'SENIM',
        'UZ_PAYBOX': 'Paybox VM'
      },
      'ProductStatus': {
        'CANCELLED': 'canceled',
        'CART': 'shopping cart',
        'CART_CANCELLED': 'canceled',
        'DISCARDED': 'Discarded ',
        'PAID_CANCELLED': 'cancelled ',
        'RECEIVED': 'delivered',
        'REFUNDED': 'refund',
        'REGISTER': 'registration',
        'RESERVED': 'created',
        'TRANSFER': 'sent'
      },
      'SourceSystem': {
        'CALLCENTER': 'Call-center',
        'CASHBOX': 'Cash',
        'CONFECTIONARY': 'Confectionery',
        'INSTAGRAM': 'Instagram',
        'KIOSK': 'Kiosk',
        'MANAGER': 'Manager',
        'ONLINE': 'Website',
        'ONLINE_APP': 'app/application',
        'TELEGRAM': 'Telegram bot',
        'WEBKASSA': 'webkassa',
        'WHATSAPP': 'Whatsapp'
      },
      'StorageInvoiceStatus': {
        'ACCEPTED': 'accepted',
        'CANCELLED': 'canceled',
        'NEW': 'created',
        'REJECTED': 'rejected',
        'SENT': 'sent'
      },
      'TimeInterval': {
        'day': 'Date',
        'month': 'Month',
        'week': 'A week',
        'year': 'Year'
      },
      'TimesheetType': {
        'ABSENCE': 'Absence ',
        'ATTENDANCE': 'Turnout',
        'HOLIDAY': 'Holiday',
        'SICK': 'Hospital',
        'VACATION': 'Vacation'
      }
    },
    'enum-select': {
      'placeholder': {
        'choose': 'Choose'
      }
    },
    'error-handler': {
      'limit': 'Product limit exceeded: {{product}}'
    },
    'event': {
      'COIN_EARNED': 'bonus accrued',
      'COMPANY_INFO_SAVED': 'data about the legal entity',
      'FISCALIZATION_REFUND': 'receipt(refund)',
      'FISCALIZATION_SELL': 'check',
      'none': 'sms has not been defined',
      'ORDER_ARCHIVED': 'archived',
      'ORDER_CANCELLED': 'cancelled',
      'ORDER_COMPLETED': 'completed',
      'ORDER_CREATED': 'created',
      'ORDER_CURBSIDE_PICKUP': 'curbside pickup ',
      'ORDER_CURBSIDE_PICKUP_SEEN': 'curbside pickup [cashier]',
      'ORDER_DECORED': 'issued',
      'ORDER_INITED': 'registration',
      'ORDER_MODIFIED': 'modified',
      'ORDER_MODIFYING': 'started modification',
      'ORDER_PACKED': 'packaged',
      'ORDER_PAID': 'paid',
      'ORDER_RECEIVED': 'delivered',
      'ORDER_REFUNDED': 'refund',
      'ORDER_RETURNED': 'released',
      'ORDER_SHIPPED': 'on delivery',
      'ORDER_TAKEN': 'accepted',
      'ORDER_TRANSFERRED': 'rescheduled',
      'ORDER_UNARCHIVED': 'unzipped/unarchived',
      'PAY_INVOICE_SENT': 'invoice for payment',
      'PAYMENT_INVOICE_GENERATED': 'invoice',
      'PAYMENT_STARTED': 'payment',
      'PRODUCT_INVOICE_GENERATED': 'the release of stocks to the side',
      'PRODUCT_REFUNDED': 'partial refund.',
      'PUSH_NOTIFICATION_CREATED': 'notification(push)',
      'SERVICE_INVOICE_GENERATED': 'act of work performed (services rendered)',
      'SMS_NOTIFICATION_CREATED': 'sms has been created',
      'SMS_NOTIFICATION_SENT': 'SMS has been sent '
    },
    'event-diff': {
      'changeData': 'Date of change',
      'changeOrder': 'The order has been changed(a)',
      'noChange': 'No changes',
      'table': {
        'body': {
          'num': 'Pcs (pieces)'
        },
        'head': {
          'after': 'After',
          'before': 'Before '
        }
      },
      'title': 'Order change history',
      'ts': {
        'discount': 'a discount: {{pi}}'
      }
    },
    'faq-list': {
      'answer': 'Answer',
      'answerHelpful': 'Consider the answer useful',
      'isAnswerHelpfulForYou': 'The answer turned out to be useful for you',
      'no': 'No',
      'search': 'Search',
      'title': 'FAQ',
      'yes': 'Yes'
    },
    'feedback': {
      'confirmRemove': 'Do you really want to delete the review?'
    },
    'file-list': {
      'ng': {
        'delete': 'Delete a file',
        'file': 'Temporary file',
        'success': '{{ file }} (uploaded {{ date }} according to Astana time)'
      }
    },
    'file-upload': {
      'mb': 'MB',
      'size': 'Maximum size'
    },
    'form': {
      'fillRequiredFields': 'Specify the required fields'
    },
    'gis-address': {
      'address': 'Specify the address',
      'btn': {
        'address': 'Specify the dialed address',
        'refusal': 'Refusal'
      },
      'delivery-zone': 'Delivery area',
      'flat': 'Flat',
      'floor': 'floor',
      'noDelivery': 'We do not deliver',
      'noFind': 'Address not found',
      'p': 'P',
      'search': 'Search...',
      'shop': 'The store',
      'showMap': 'Show the map',
      'startText': 'Start typing',
      'text': 'does not deliver to the address'
    },
    'hx-loader': {
      'noData': 'There is no data'
    },
    'invoice-select': {
      'from': 'from',
      'placeholder': {
        'chooseInvoice': 'Select the invoice'
      }
    },
    'lang': {
      'en': 'English',
      'kk': 'Kazakh',
      'ru': 'Russian',
      'us': 'English'
    },
    'loading': {
      'create': {
        'finished': 'Completing the creation of the order',
        'order': 'Creating an order'
      },
      'order': {
        'send': 'Sending the order'
      },
      'save': 'Saving data...'
    },
    'manual-address': {
      'address': 'Delivery address ',
      'flat': 'Flat ',
      'floor': 'Floor ',
      'p': 'P'
    },
    'modal-user': {
      'birthDate': 'Date of birth',
      'client': 'Client',
      'mobile': 'Mobile phone',
      'user': 'User'
    },
    'no': 'No',
    'nt': {
      'saved': 'Data saved'
    },
    'operationDayClosed': 'The operating day is closed',
    'order-receipt': {
      'address': 'Delivery Address',
      'cancellation': 'Reason for cancellation',
      'cashier': 'Cashier',
      'check': 'receipt',
      'checkHidden': 'The receipt is printed',
      'client': 'Client',
      'footer': '© Happy Tech App',
      'ng': {
        'courier': 'Courier'
      },
      'noCheck': 'WITHOUT A RECEIPT',
      'note': 'Note',
      'paid': 'Thank you for your purchase!',
      'paidMethod': 'Payment method',
      'printCheck': 'Print the receipt',
      'printedCheck': 'The receipt is printed',
      'return': 'Refund',
      'series': 'VAT Series',
      'table': {
        'body': {
          'discount': 'Discounts',
          'text': 'including VAT: 12%',
          'total': 'Total',
          'totalAll': 'TOTAL'
        },
        'head': {
          'name': 'Name',
          'num': 'Quantity',
          'sum': 'The amount',
          'weight': 'Weight'
        }
      },
      'text-1': 'FN KKT',
      'text-10': 'VAT Series',
      'text-11': 'SNO',
      'text-2': 'The PH of the KKT',
      'text-3': 'FN',
      'text-4': 'FD',
      'text-5': 'FD',
      'text-6': 'Check',
      'text-7': 'Date',
      'text-8': 'Change',
      'text-9': 'FTS website',
      'thanks': 'Thanks for the purchase!',
      'timeDelivery': 'Delivery Time',
      'timePickup': 'Pick-up time',
      'user': 'Recipient'
    },
    'order-refunded-list': {
      'from': 'from',
      'table': {
        'body': {
          'allTotal': 'Total',
          'discount': 'Discounts',
          'total': 'Total'
        },
        'head': {
          'name': 'Name',
          'num': 'Quantity',
          'price': 'Price',
          'sum': 'The amount',
          'weight': 'Weight'
        }
      }
    },
    'paidOrderChangeForbidden': 'You cannot change the price in a paid order',
    'pickups': {
      'notfound': 'Pickup time not found'
    },
    'product-info-select': {
      'placeholder': {
        'loading': 'The search is underway...',
        'name': 'Enter the name',
        'noFind': 'Not found',
        'search': 'For search, start typing'
      }
    },
    'product-list': {
      'alert': 'The registration is disabled on the selected date',
      'autoDeliveryInfo': 'Delivery is added when the address is specified',
      'btn': {
        'divide': 'Divide/To share',
        'refusal': 'Refusal'
      },
      'decorationDisabled': 'Registration is disabled on the selected date',
      'hiddenCategories': 'Hidden categories',
      'hideCategory': 'Hide category',
      'productListEmpty': 'The list of cakes is empty',
      'productNotForSale': 'The product is not for sale',
      'receiveAfterTime': '{title.ru } will go on sale after {receiveAfterTime}',
      'reserveNoFreeProduct': 'Booking is not possible. There are no available products',
      'showCategory': 'Show category',
      'ts': {
        'noChoose': 'No category and/or date selected'
      }
    },
    'receipt': {
      'fiscalCheck': 'Fiscal receipt',
      'fiscalization': 'Fiscalization',
      'offlineMode': 'The receipt is generated offline',
      'wkCashboxFactoryNumber': 'CFN',
      'wkCashboxIdentificationNumber': 'INC OFD',
      'wkCashboxRegistrationNumber': 'CRN',
      'wkFiscalDate': 'Date',
      'wkFiscalNumber': 'FN'
    },
    'rejection-list': {
      'address': 'Address',
      'btn': {
        'search': 'search'
      },
      'city': 'City',
      'data': 'Date',
      'delivery': 'Delivery',
      'failures': 'Refusals',
      'pickup': 'Pickup',
      'placeholder': {
        'chooseCity': 'Select a city',
        'name': 'Full name or phone number'
      },
      'products': 'Products',
      'promo': 'Promo',
      'registration': 'Clearance',
      'searchAddress': 'Search by address',
      'shop': 'Shop',
      'table': {
        'head': {
          'absent': 'is missing',
          'address': 'Addresses',
          'city': 'City',
          'client': 'Client',
          'data': 'Date',
          'delivery': 'Delivery',
          'note': 'The note',
          'order': 'Order ID',
          'pickup': 'Pickup',
          'products': 'Products',
          'promo': 'Promo',
          'registration': 'Decoration',
          'shop': 'Shop',
          'timeCreate': 'Creation time'
        }
      }
    },
    'select': {
      'category': 'Select a category'
    },
    'sms-info-modal': {
      'send': 'Sent to the provider',
      'sendClient': 'Sent to the client',
      'title': 'Information about SMS'
    },
    'sms': {
      'status': {
        'DELETED': 'it the message was deleted',
        'DELIVERED': 'delivered',
        'EXPIRED': 'expired SMS period',
        'FAILED': 'internal error SMS',
        'INVALID': 'internal SMS error the',
        'NEW': 'created',
        'SENT': 'sent'
      }
    },
    'store-search': {
      'placeholder': {
        'loader': 'A search is underway...',
        'nameSearch': 'Enter the name of the store',
        'noFind': 'Not found'
      }
    },
    'store-select': {
      'placeholder': {
        'chooseShop': 'Select a store'
      }
    },
    'user-search': {
      'placeholder': {
        'loader': 'A search is underway...',
        'name': 'Enter the user\'s name or phone number',
        'noFind': 'Not found'
      }
    },
    'user-select': {
      'placeholder': {
        'loader': 'The search is underway...',
        'name': 'Enter the user\'s name or phone number',
        'noFind': 'Not found'
      }
    },
    'yes': 'Yes'
  },
  '\'hx': {
    'client-search': {
      'placeholder': {
        'startSearch': 'To search, start typing'
      }
    },
    'comment-add': {
      'mention': 'By selecting a label, an additional notification will be sent'
    },
    'error-handler': {
      'balance': 'In {{msg}}, top up your balance with the following products: {{product}}'
    },
    'order-event-list': {
      'ts': {
        'noFindList': 'The cancellation order was not found, please contact technical support',
        'orderCancel': 'The cancellation order was not found, check if the order has been paid'
      }
    },
    'product-info-select': {
      'placeholder': {
        'search': 'To search, start typing'
      }
    },
    'product-list': {
      'notAbleToReserve': '{title.ru } - minimum number of days to receive the order: {minOrderDay}, sale after {receiveAfterTime}',
      'notAbleToReserveUntil': '{title.ru } - minimum number of days to accept an order: {minOrderDay}, acceptance before {untilOrderTime}, sale after {receiveAfterTime}'
    },
    'sms': {
      'status': {
        'ACCEPTED': 'the message is in the received state, i.e. it was read manually on behalf of the subscriber by the client service',
        'REJECTED': 'message was rejected, occurs when the operator refuses to transmit',
        'UNDELIVERED': 'not delivered, the reason is in the code'
      }
    },
    'store-search': {
      'placeholder': {
        'startSearch': 'To search, start typing'
      }
    },
    'user-search': {
      'placeholder': {
        'search': 'To search, start typing'
      }
    },
    'user-select': {
      'placeholder': {
        'search': 'To search, start typing'
      }
    }
  }
};
